import {
  request
} from "./chunk-HOV4UELG.js";
import {
  getReference,
  getRefsObject,
  mapCreateQuery,
  mapDeleteQuery,
  mapPage,
  mapPagePath,
  mapQuery,
  mapUpdateQuery,
  mappers_exports
} from "./chunk-Y26CKNJF.js";
import "./chunk-ZUUF2P4F.js";
import {
  __export
} from "./chunk-UICA3PK6.js";
import "./chunk-GGNOJ77I.js";

// src/config/endpoints.ts
var endpoints_exports = {};
__export(endpoints_exports, {
  get: () => get
});

// src/config/mappers.ts
var mapConfig = (res) => {
  const routes = {};
  const translations = {};
  if (res.data.settings.routes) {
    for (const route of res.data.settings.routes) {
      routes[route.name] = {
        title: route.title,
        href: route.path || ""
      };
    }
  }
  if (res.data.settings.translation) {
    for (const translation of res.data.settings.translation) {
      translations[translation.name] = translation.value;
    }
  }
  return {
    settings: {
      ...res.data.settings,
      socials: res.data.settings.socials || {},
      homepage: getReference(
        { ...res.data.settings.homepage },
        getRefsObject(res.data.settings.refs)
      ),
      routes,
      translations,
      plugins: (res.data.settings.plugins || []).map(
        (plugin) => plugin.script
      )
    },
    themes: (res.data.themes || []).map((theme) => ({
      id: theme.id,
      title: theme.title,
      isDefault: theme.default,
      logo: theme.logo ? { src: theme.logo.path } : null,
      neutrals: theme.neutrals,
      colors: theme.colors
    })),
    languages: (res.data.languages || []).map((language) => ({
      id: language.languageId,
      title: language.title,
      nativeTitle: language.nativeTitle,
      name: language.name,
      code: language.languageId,
      isDefault: language.default,
      isRightDirection: language.isRightDirection || false
    })),
    language: res.data.languageId
  };
};

// src/config/endpoints.ts
var get = (environment, params) => request(
  environment,
  {
    method: "get",
    url: `/settings/${params.language}`
  },
  {
    res: mapConfig
  }
);

// src/page/endpoints.ts
var endpoints_exports2 = {};
__export(endpoints_exports2, {
  findPath: () => findPath,
  get: () => get2,
  globalSearch: () => globalSearch,
  preview: () => preview,
  searchAllDomains: () => searchAllDomains
});
var get2 = (environment, params) => request(
  environment,
  {
    method: "get",
    url: `/pages/path?path=${params.path}&IsMobile=${(params == null ? void 0 : params.isMobile) || false}`
  },
  {
    res: mapPage
  }
);
var preview = (environment, id) => request(
  environment,
  {
    method: "get",
    url: `/pages/preview/${id}`
  },
  {
    res: mapPage
  }
);
var findPath = (environment, params) => request(
  environment,
  {
    method: "get",
    url: `/pages/${params.language}/find-path?path=${params.path}`
  },
  {
    res: mapPagePath
  }
);
var globalSearch = (environment, params) => request(environment, {
  method: "get",
  url: `/pages/${params.language}/global-search?pageLength=200&search=${params.search}`
});
var searchAllDomains = (environment, params) => request(environment, {
  method: "get",
  url: `/pages/${params.language}/search-all-domains?Text=${params.search}`
});

// src/query/endpoints.ts
var endpoints_exports3 = {};
__export(endpoints_exports3, {
  create: () => create,
  form: () => form,
  remove: () => remove,
  run: () => run,
  update: () => update
});
var run = (environment, params, mappings) => request(
  environment,
  {
    method: "get",
    url: `/queries/${params.language}/${params.name}/run?${params.query || ""}`
  },
  {
    res: (response) => ({
      ...response,
      data: mapQuery(response.data, mappings || [])
    })
  }
);
var form = (environment, params, payload) => request(environment, {
  method: "post",
  url: `/queries/${params.language}/${params.name}/run-form`,
  headers: {
    "Content-Type": "multipart/form-data"
  },
  data: payload
});
var create = (environment, params, payload) => request(
  environment,
  {
    method: "post",
    url: `/queries/${params.language}/${params.name}/run`,
    data: payload
  },
  {
    req: mapCreateQuery
  }
);
var update = (environment, params, payload) => request(
  environment,
  {
    method: "post",
    url: `/queries/${params.language}/${params.name}/run`,
    data: payload
  },
  {
    req: mapUpdateQuery
  }
);
var remove = (environment, params, payload) => request(
  environment,
  {
    method: "post",
    url: `/queries/${params.language}/${params.name}/run`,
    data: payload
  },
  {
    req: mapDeleteQuery
  }
);

// src/site/endpoints.ts
var endpoints_exports4 = {};
__export(endpoints_exports4, {
  get: () => get3
});

// src/site/mappers.ts
var mapSite = (res) => {
  return {
    id: res.data.id,
    cdn: res.data.cdn,
    key: res.data.key,
    service: res.data.service,
    title: res.data.title,
    url: res.data.url
  };
};

// src/site/endpoints.ts
var get3 = (environment, host) => request(
  environment,
  {
    method: "get",
    url: `/sites/${host}`
  },
  {
    res: mapSite
  }
);
export {
  endpoints_exports as configService,
  mappers_exports as mappers,
  endpoints_exports2 as pageService,
  endpoints_exports3 as queryService,
  request,
  endpoints_exports4 as siteService
};
